/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Build_Your_Own_Ai_Morning21Inputs */

const en__field_enum_build_your_own_ai_morning21 = /** @type {(inputs: _Field_Enum_Build_Your_Own_Ai_Morning21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`morning only`)
};

const de__field_enum_build_your_own_ai_morning21 = /** @type {(inputs: _Field_Enum_Build_Your_Own_Ai_Morning21Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nur vormittags`)
};

/**
* | output |
* | --- |
* | "morning only" |
*
* @param {_Field_Enum_Build_Your_Own_Ai_Morning21Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_build_your_own_ai_morning21 = /** @type {((inputs?: _Field_Enum_Build_Your_Own_Ai_Morning21Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Build_Your_Own_Ai_Morning21Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_build_your_own_ai_morning21(inputs)
	return de__field_enum_build_your_own_ai_morning21(inputs)
});
export { _field_enum_build_your_own_ai_morning21 as "_field_enum_BUILD_YOUR_OWN_AI_MORNING" }